<div class="app-footer">
  <span>{{ 'app.footer_fec_notice' | translate }}</span>
  <span class="footer-links">
    <a href="https://resistmap.com/legal#privacy" target="_blank">{{
      'app.privacy_policy' | translate
    }}</a>
    &nbsp;|&nbsp;
    <a href="https://resistmap.com/legal#terms" target="_blank">{{
      'app.terms_and_conditions' | translate
    }}</a>
  </span>
</div>
